import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import style from './Pagination.module.scss';
import TimeClickFileBlue from '../../../assets/images/TimeClockFileBlue.svg';

import useWindowDimensions from '../../../helpers/hooks/useWindowDimensions';

interface IProps {
  setPage: (payload: number) => void;
  page: number;
  setData: Function;
  lastPage: number;
  searchId: number;
  inn: string;
}

const Pagination = ({ setPage, page, setData, lastPage, searchId, inn }: IProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [firstDotsVisible, setFirstDotsVisible] = useState(false);
  const [goTo, setGoTo] = useState('');
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (page >= 5 && lastPage > 10) setFirstDotsVisible(true);
    if (page < 5) setFirstDotsVisible(false);
  }, [setFirstDotsVisible, page, lastPage]);

  const items = [];
  const limit = page + 4 < lastPage ? page + 4 : lastPage;
  const minPage = page + 4 >= lastPage ? lastPage - 9 : page - 3;

  const LIMIT = lastPage > 10 ? limit : lastPage;
  const MIN = lastPage > 10 ? minPage : 2;
  if (page >= 5) {
    for (let number = MIN; number <= LIMIT; number++) {
      items.push(
        <button
          className={`${style.paginationItem} ${page === number && style.active}`}
          type="button"
          key={number}
          value={number}
          onClick={(event) => {
            setPage(+event.currentTarget.value);
            setData(+event.currentTarget.value);
          }}
        >
          {number}
        </button>,
      );
    }
  } else if (lastPage < 10) {
    for (let number = 2; number <= lastPage; number++) {
      items.push(
        <button
          className={`${style.paginationItem} ${page === number && style.active}`}
          type="button"
          key={number}
          value={number}
          onClick={(event) => {
            setPage(+event.currentTarget.value);
            setData(+event.currentTarget.value);
          }}
        >
          {number}
        </button>,
      );
    }
  } else {
    for (let number = 2; number <= 10; number++) {
      items.push(
        <button
          className={`${style.paginationItem} ${page === number && style.active}`}
          type="button"
          key={number}
          value={number}
          onClick={(event) => {
            setPage(+event.currentTarget.value);
            setData(+event.currentTarget.value);
          }}
        >
          {number}
        </button>,
      );
    }
  }

  const generateUrl = async (id: number, innValue: string) => {
    setIsLoading(true);
    try {
      if (id) {
        const res = await fetch(`/api/reports-download-urls/suppliers_search/${id}`, {
          credentials: 'same-origin',
        });
        const url = await res.json();
        window.location.href = url.downloadUrl;
      }
      if (innValue) {
        const res = await fetch(`/api/reports-download-urls/bids?inn=${innValue}`, {
          credentials: 'same-origin',
        });
        const url = await res.json();
        window.location.href = url.downloadUrl;
      }
    } finally {
      setIsLoading(false);
    }
    return '';
  };

  return (
    <div className={style.pagination}>
      <div className={style.buttons}>
        {width > 1919 && (
          <button
            className={`${style.paginationItem} ${page === 1 && style.active}`}
            type="button"
            value={1}
            onClick={(event) => {
              setPage(+event.currentTarget.value);
              setData(+event.currentTarget.value);
            }}
          >
            1
          </button>
        )}
        {firstDotsVisible && width > 1919 ? (
          <button type="button" className={style.dots}>
            &middot;&middot;&middot;
          </button>
        ) : null}
        {width > 1919 && items}
        {width > 1919 && lastPage > 10 && page < lastPage - 4 ? (
          <button type="button" className={style.dots}>
            &middot;&middot;&middot;
          </button>
        ) : null}
        <button
          type="button"
          aria-label="Arrow"
          className={style.start}
          onClick={() => {
            setPage(1);
            setData(1);
          }}
        />
        <button
          type="button"
          aria-label="Arrow"
          className={style.prev}
          disabled={page === 1}
          onClick={() => {
            setPage(page - 1);
            setData(page - 1);
          }}
        />
        <button
          type="button"
          aria-label="Arrow"
          className={style.next}
          disabled={page === lastPage}
          onClick={() => {
            setPage(page + 1);
            setData(page + 1);
          }}
        />
        <button
          type="button"
          aria-label="Arrow"
          className={style.end}
          onClick={() => {
            setPage(lastPage);
            setData(lastPage);
          }}
        />
      </div>

      <form
        className={style.goto}
        onSubmit={(event) => {
          event.preventDefault();
          if (+goTo <= lastPage && +goTo > 0) {
            setPage(+goTo);
            setData(+goTo);
            setGoTo('');
            return;
          }
          setGoTo('');
          // eslint-disable-next-line no-alert
          alert('Укажите правильную страницу');
        }}
      >
        <p className={style.gotoTitle}>Перейти на страницу</p>
        <input
          type="search"
          value={goTo}
          onChange={(event) => setGoTo(event.target.value)}
          className={style.gotoInput}
        />
        <p className={style.gotoCount}>из {lastPage}</p>
      </form>

      <button type="button" className={style.downloadAll} onClick={() => generateUrl(searchId, inn)}>
        {isLoading ? <Spin /> : <img src={TimeClickFileBlue} alt="Скачать отчёт по результату поиска" />}
        Скачать отчёт по результату поиска
      </button>
    </div>
  );
};

export default Pagination;
